/**
 * Button GUI component
 */

import { Button } from "@mantine/core";
import type { GuiButtonElement } from "../types";
import { useWebSocket } from "../WebSocket";

interface GuiButtonProps {
  element: GuiButtonElement;
}

export function GuiButton({ element }: GuiButtonProps) {
  const { sendGuiEvent } = useWebSocket();

  const handleClick = () => {
    sendGuiEvent(element.uuid, "click", null);
  };

  // Map color string to Mantine color
  const getColor = () => {
    if (!element.color) return undefined;
    const colorMap: Record<string, string> = {
      blue: "blue",
      red: "red",
      green: "green",
      yellow: "yellow",
      orange: "orange",
      purple: "grape",
      gray: "gray",
    };
    return colorMap[element.color] || element.color;
  };

  return (
    <Button
      fullWidth
      onClick={handleClick}
      disabled={element.disabled}
      color={getColor()}
      variant="light"
      size="sm"
      style={{ marginBottom: "8px" }}
    >
      {element.label}
    </Button>
  );
}
